// extracted by mini-css-extract-plugin
export default {"reportTable":"Reports_reportTable__AlTkK"};